"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.promise.finally");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _Formio = _interopRequireDefault(require("../../Formio"));

var _fileUtils = require("../../utils/fileUtils");

var _WithFileUtils = require("../../utils/WithFileUtils");

var _WithLogic2 = _interopRequireDefault(require("../../utils/WithLogic"));

var _File = _interopRequireDefault(require("../file/File"));

var _File2 = _interopRequireDefault(require("../file/File.form"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var tableHeaderRowStyles = 'height: 30px';
var borderNone = 'border: none;';
var borderNoneObj = {
  style: borderNone
};
var commonTableCellStyles = 'white-space: nowrap; overflow: hidden;';
var commonTableCellStylesWithEllipsisStyles = commonTableCellStyles + 'text-overflow: ellipsis;';

var _default = function _default(setting) {
  var baseUrl = setting.baseUrl,
      catalogsUrl = setting.catalogsUrl;

  var CategoryFile =
  /*#__PURE__*/
  function (_WithLogic) {
    _inherits(CategoryFile, _WithLogic);

    function CategoryFile() {
      _classCallCheck(this, CategoryFile);

      return _possibleConstructorReturn(this, _getPrototypeOf(CategoryFile).apply(this, arguments));
    }

    _createClass(CategoryFile, [{
      key: "createLabel",
      value: function createLabel(container) {
        if (!this.component.hideTitles) {
          _get(_getPrototypeOf(CategoryFile.prototype), "createLabel", this).call(this, container);
        }
      } // eslint-disable-next-line max-statements

    }, {
      key: "build",
      value: function build(state, getViewResolve) {
        // Restore the value.
        //Изменение порядка вывода элементов
        this.restoreValue();
        var labelAtTheBottom = this.component.labelPosition === 'bottom';
        this.createElement();

        if (!labelAtTheBottom && !getViewResolve) {
          this.createLabel(this.element);
        }

        if (this.component.hideTitles) {
          this.element.classList.add('without-th');
        }

        var isWithoutCategory = this.component.variant === 'withoutCategory';
        var isWithoutColumnCategory = !!this.component.hideCategory;
        this.inputsContainer = this.ce('div', null, this.ce('div', {
          style: "display: flex; align-items: flex-start; ".concat(getViewResolve ? '' : 'overflow-x: auto'),
          class: 'category-file-tables-container'
        }, [!isWithoutCategory && this.ce('table', {
          class: 'table category-select-table',
          style: "flex: 0 0 200px; ".concat(isWithoutColumnCategory ? 'display: none' : '')
        }), this.ce('table', {
          class: 'table files-table',
          style: 'flex: 1 1 100%'
        })]));
        this.errorContainer = this.element;
        this.createErrorElement();
        this.listContainer = this.buildList();
        this.uploadContainer = this.buildUpload();
        this.hiddenFileInputElement = this.buildHiddenFileInput();
        this.hook('input', this.hiddenFileInputElement, this.inputsContainer);

        if (!this.component.hideTitles) {
          if (!isWithoutCategory) {
            var categorySelectTable = this.inputsContainer.querySelector('.category-select-table');
            categorySelectTable.appendChild(this.ce('tbody', {
              style: tableHeaderRowStyles
            }, this.ce('tr', {
              class: 'title-row'
            }, [!isWithoutCategory && !isWithoutColumnCategory && this.ce('th', {
              class: 'drag-container title-category'
            }, this.ce('span', null).textContent = this.t('category'))])));
          }

          var _filesTable = this.inputsContainer.querySelector('.files-table');

          var headerTitleCellStyles = commonTableCellStylesWithEllipsisStyles + 'max-width: 400px;';
          var headerSizeCellStyles = commonTableCellStylesWithEllipsisStyles + 'max-width: 100px;';
          var headerAuthorCellStyles = commonTableCellStylesWithEllipsisStyles + 'max-width: 250px;';
          var headerUploadDateCellStyles = commonTableCellStylesWithEllipsisStyles + 'max-width: 162px; width: 162px;';

          _filesTable.appendChild(this.ce('tbody', {
            style: tableHeaderRowStyles
          }, this.ce('tr', {
            class: 'title-row'
          }, [this.ce('th', {
            class: 'drag-container title-file',
            style: headerTitleCellStyles
          }, this.ce('span', null).textContent = this.t('file')), this.component.isShowSize && this.ce('th', {
            class: 'drag-container title-size',
            style: headerSizeCellStyles
          }, this.ce('span', null).textContent = this.t('Size')), this.component.isShowAuthor && this.ce('th', {
            class: 'drag-container title-author',
            style: headerAuthorCellStyles
          }, this.ce('span', null).textContent = this.t('author')), this.component.isShowUploadDate && this.ce('th', {
            class: 'drag-container title-upload-date',
            style: headerUploadDateCellStyles,
            title: this.t('uploadDate')
          }, this.ce('span', null).textContent = this.t('uploadDate')), this.ce('th', {
            style: 'width: 50px'
          }), this.ce('th', {
            style: 'width: 50px'
          })])));
        }

        var filesTable = this.inputsContainer.querySelector('.files-table');

        switch (this.component.variant) {
          case 'staticSet':
            {
              this.buildStaticCategory(getViewResolve);
              break;
            }

          case 'dynamicSet':
            {
              this.buildSelect(getViewResolve);
              break;
            }

          default:
            {
              setTimeout(function () {
                getViewResolve && getViewResolve();
              }, 0);
            }
        }

        this.errorContainer = this.inputsContainer;
        filesTable.appendChild(this.listContainer);
        var uploadTableRowTbody = this.ce('tbody', {
          style: 'border-top: none;'
        }, this.ce('tr', {
          class: 'upload-table-row',
          style: borderNone
        }));
        var uploadTableRow = uploadTableRowTbody.querySelector('.upload-table-row');
        var uploadTableCell = this.ce('td', {
          class: 'upload-table-cell',
          style: borderNone,
          colspan: '6'
        });

        if (!this.viewOnly) {
          uploadTableCell.appendChild(this.hiddenFileInputElement);
        } else {
          uploadTableRow.style.display = 'none';
        }

        uploadTableCell.appendChild(this.uploadContainer);
        this.addWarnings(uploadTableCell);
        this.buildUploadStatusList(uploadTableCell);
        uploadTableRow.appendChild(uploadTableCell);
        filesTable.appendChild(uploadTableRowTbody);
        this.setInputStyles(this.inputsContainer);
        this.element.appendChild(this.inputsContainer); // inputsContainer должен быть общим контейнером, используется на перерисовке
        // this.inputsContainer = fileContainer;

        if (labelAtTheBottom) {
          this.createLabel(this.element);
        }

        this.createDescription(this.element);
        this.autofocus(); // Disable if needed.

        if (this.shouldDisable) {
          this.disabled = true;
        }

        if (this.viewOnly && this.titleSelect) {
          this.titleSelect.setAttribute('disabled', true);
        }

        this.attachLogic();
        return this.element;
      }
    }, {
      key: "refreshDOM",
      value: function refreshDOM() {
        // Don't refresh before the initial render.
        if (this.listContainer && this.uploadContainer) {
          // Refresh file list.
          var newList = this.buildList();
          var filesTable = this.inputsContainer.querySelector('.files-table');
          filesTable.replaceChild(newList, this.listContainer);
          this.listContainer = newList; // Refresh upload container.

          var newUpload = this.buildUpload();
          var uploadTableCell = this.inputsContainer.querySelector('.upload-table-cell');
          uploadTableCell.replaceChild(newUpload, this.uploadContainer);
          this.uploadContainer = newUpload;
        }
      }
    }, {
      key: "buildList",
      value: function buildList(isGetView) {
        if (this.component.image) {
          return this.buildImageList();
        } else {
          return this.buildFileList(isGetView);
        }
      }
    }, {
      key: "getView",
      value: function getView(value) {
        var _this3 = this;

        this.dataValue = value;
        var promise = new Promise(function (resolve, reject) {
          var resolveWithElement = function resolveWithElement() {
            resolve(element);
          };

          var element = _this3.build(undefined, resolveWithElement);

          var newList = _this3.buildList(resolveWithElement);

          var filesTable = element.querySelector('.files-table');
          filesTable.replaceChild(newList, _this3.listContainer);
        }).then(function (element) {
          return element.innerHTML;
        });
        return promise;
      }
    }, {
      key: "buildStaticCategory",
      value: function buildStaticCategory(getViewResolve) {
        var _this4 = this;

        var categorySelectTable = this.inputsContainer.querySelector('.category-select-table');
        categorySelectTable && categorySelectTable.appendChild(this.ce('tbody', borderNoneObj, this.ce('tr', borderNoneObj, this.ce('td', borderNoneObj, this.ce('p', null)))));

        if (this.component.categoryCode) {
          this.getCategory().then(function () {
            if (categorySelectTable) {
              categorySelectTable.querySelector('p').textContent = _this4.categoryTitle;
            }
          }).finally(function () {
            getViewResolve && getViewResolve();
          });
        }
      }
    }, {
      key: "buildSelect",
      value: function buildSelect(getViewResolve) {
        var _this5 = this;

        var categorySelectTable = this.inputsContainer.querySelector('.category-select-table');
        categorySelectTable && categorySelectTable.appendChild(this.ce('tbody', borderNoneObj, this.ce('tr', borderNoneObj, this.ce('td', borderNoneObj))));
        var categorySelectTableSelectCell = categorySelectTable.querySelector('td');

        var onSelectChange = function onSelectChange(event) {
          _this5.categoryCode = event.target.value;

          _this5.setCategoryForFileUrl();

          _this5.updateFilesCategory();
        };

        categorySelectTableSelectCell.appendChild(this.ce('div', {
          style: 'margin-top: 2px; margin-bottom: 24px;',
          class: 'form-group formio-component formio-component-select'
        }, this.ce('div', {
          style: 'margin-top: 2px; margin-bottom: 0px;',
          class: 'choices form-group formio-choices'
        }, this.ce('select', {
          class: 'form-control',
          onChange: function onChange(event) {
            onSelectChange(event);
          }
        }))));
        this.titleSelect = categorySelectTableSelectCell.querySelector('select');
        this.getCategories().then(function () {
          if (_this5.categoriesOptions) {
            _this5.fileCategorySelect = categorySelectTableSelectCell.querySelector('select');

            _this5.categoriesOptions.forEach(function (option) {
              _this5.fileCategorySelect.appendChild(_this5.ce('option', {
                value: option.value
              }, _this5.ce('span', null).textContent = option.label));
            });

            if (!_this5.component.categoryCode) {
              _this5.dataReady.then(function () {
                var uploadedFile = _this5.data[_this5.component.key][0];

                if (uploadedFile) {
                  var category = uploadedFile.category.split('@')[0];
                  var optionSelector = "option[value='".concat(category, "']");

                  _this5.fileCategorySelect.querySelector(optionSelector).setAttribute('selected', 'selected');

                  _this5.categoryCode = category;

                  _this5.updateFilesCategory();
                }
              }).finally(function () {
                getViewResolve && getViewResolve();
              });
            }
          }
        });
      }
    }, {
      key: "setCategoryForFileUrl",
      value: function setCategoryForFileUrl() {
        var categoryParamIndex = this.component.url.indexOf('?category=');

        if (categoryParamIndex !== -1) {
          this.component.url = this.component.url.slice(0, categoryParamIndex);
        }

        this.component.url = "".concat(this.component.url, "?category=").concat(this.categoryCode);
      }
    }, {
      key: "updateFilesCategory",
      value: function updateFilesCategory() {
        var _this6 = this;

        this.dataValue = this.dataValue.map(function (fileData) {
          return _objectSpread({}, fileData, {
            category: _this6.categoryCode
          });
        });
      }
    }, {
      key: "getCategories",
      value: function getCategories() {
        var _this7 = this;

        var lang = this.i18next.language;
        var url = "".concat(catalogsUrl, "/catalogItems?catalogCode=").concat(encodeURIComponent(this.component.catalogCode), "&lang=").concat(lang);
        url = url.startsWith('http') ? url : "".concat(baseUrl, "/").concat(url);
        var options = this.component.authenticate ? {} : {
          noToken: true
        };
        options.header = this.requestHeaders;
        return _Formio.default.makeRequest(this.options.formio, 'select', url, 'GET', null, options).then(function (response) {
          var items = response.map(function (i) {
            return {
              value: i.code,
              label: i.title
            };
          });
          _this7.categoriesOptions = items;
          _this7.categoryCode = _this7.categoriesOptions[0].value;

          _this7.setCategoryForFileUrl();
        }).catch(function (err) {
          console.warn("Unable to load resources");
        });
      }
    }, {
      key: "getCategory",
      value: function getCategory() {
        var _this9 = this;

        var lang = this.i18next.language;
        var url = "".concat(catalogsUrl, "/catalogItem?code=").concat(encodeURIComponent(this.component.categoryCode), "@").concat(encodeURIComponent(this.component.catalogCode), "&lang=").concat(lang);
        url = url.startsWith('http') ? url : "".concat(baseUrl, "/").concat(url);
        var options = this.component.authenticate ? {} : {
          noToken: true
        };
        options.header = this.requestHeaders;
        return _Formio.default.makeRequest(this.options.formio, 'select', url, 'GET', null, options).then(function (response) {
          _this9.categoryTitle = response.title;
          _this9.categoryCode = response.code;

          _this9.setCategoryForFileUrl();
        }).catch(function (err) {
          console.warn("Unable to load resources");
        });
      }
    }, {
      key: "buildHiddenFileInput",
      value: function buildHiddenFileInput() {
        //Добавление событий Drag&Drop к HiddenFileInput
        var _this = this; // Drop event must change this pointer so need a reference to parent this.


        var element = this; // Declare Camera Instace
        // Input needs to be in DOM and "visible" (opacity 0 is fine) for IE to display file dialog.

        return this.ce('input', {
          type: 'file',
          style: 'opacity: 0; position: absolute; pointer-events: none;',
          tabindex: -1,
          // prevent focus
          onChange: function onChange() {
            _this.upload(_this.hiddenFileInputElement.files);

            _this.hiddenFileInputElement.value = '';
          },
          onDragover: function onDragover(event) {
            var fileSelectorContainer = _this.uploadContainer.firstChild;
            fileSelectorContainer.className = 'fileSelector fileDragOver';
            event.preventDefault();
          },
          onDragleave: function onDragleave(event) {
            var fileSelectorContainer = _this.uploadContainer.firstChild;
            fileSelectorContainer.className = 'fileSelector';
            event.preventDefault();
          },
          onDrop: function onDrop(event) {
            var fileSelectorContainer = _this.uploadContainer.firstChild;
            fileSelectorContainer.className = 'fileSelector';
            event.preventDefault();
            element.upload(event.dataTransfer.files);
            return false;
          }
        });
      }
    }, {
      key: "loadImage",
      value: function loadImage(fileInfo) {
        return this.fileService.downloadFile(fileInfo).then(function (result) {
          var path = result.url,
              pathPrefix = path.startsWith('/') ? '' : '/',
              url = path.startsWith('http') ? path : "".concat(baseUrl).concat(pathPrefix).concat(path);
          return url;
        });
      }
    }, {
      key: "createUploadStatus",
      value: function createUploadStatus(fileUpload) {
        var _this13 = this;

        var container;
        return container = this.ce('div', {
          class: 'file'.concat(fileUpload.status === 'error' ? ' has-error' : '')
        }, [this.ce('div', {
          class: 'list-item'
        }, [this.ce('div', {
          class: 'file-list__file-name'
        }, this.fileNameWithoutExt(fileUpload)), this.ce('div', {
          class: 'file-list__file-ext'
        }, this.fileExt(fileUpload)), this.ce('div', {
          class: 'file-list__file-size'
        }, this.fileSize(fileUpload.size)), this.ce('div', {
          class: 'file-list__file-remove'
        }, this.ce('i', {
          class: 'theme-icon-trash',
          onClick: function onClick() {
            return _this13.removeChildFrom(container, _this13.uploadStatusList);
          }
        }))]), this.ce('div', {
          class: 'progress-block'
        }, [fileUpload.status === 'progress' ? this.ce('div', {
          class: 'progress'
        }, this.ce('div', {
          class: 'progress-bar',
          role: 'progressbar',
          'aria-valuenow': fileUpload.progress,
          'aria-valuemin': 0,
          'aria-valuemax': 100,
          style: 'width:'.concat(fileUpload.progress, '%')
        }, [this.ce('span', {
          class: 'sr-only'
        }, ''.concat(fileUpload.progress, '% Complete')), this.ce('div', {
          class: 'lines'
        })])) : this.ce('div', {
          class: 'bg-'.concat(fileUpload.status)
        }, fileUpload.message)])]);
      } // Добавлен triggerChange при успешном удалении

    }, {
      key: "removeChildFrom",
      value: function removeChildFrom(element, container) {
        if (container && container.contains(element)) {
          try {
            container.removeChild(element);
          } catch (err) {
            console.warn(err);
          }
        }

        return this;
      } //Изменения: не резолвился промис dataReady для image файлов, если не было ни одного файла

    }, {
      key: "setValue",
      value: function setValue(value) {
        var _this2 = this;

        var newValue = value || [];
        this.dataValue = newValue;

        if (this.component.image) {
          this.loadingImages = [];
          var images = Array.isArray(newValue) ? newValue : [newValue];
          images.map(function (fileInfo) {
            if (fileInfo && Object.keys(fileInfo).length) {
              _this2.loadingImages.push(_this2.loadImage(fileInfo));
            }
          });

          if (this.loadingImages.length) {
            Promise.all(this.loadingImages).then(function () {
              _this2.refreshDOM();

              setTimeout(function () {
                return _this2.filesReadyResolve();
              }, 100);
            }).catch(function () {
              return _this2.filesReadyReject();
            });
          } else {
            // этого блока в исходниках не было
            this.refreshDOM();
            this.filesReadyResolve();
          }
        } else {
          this.refreshDOM();
          this.filesReadyResolve();
        }
      }
    }, {
      key: "buildFileList",
      value: function buildFileList(isGetView) {
        //Без шапки в списке файлов
        var _this = this;

        var value = this.dataValue;
        var updatedFilesTbodyContainer = this.ce('tbody', {
          class: 'files-wrapper',
          style: 'border-top: none;'
        }, [this.ce('tr', null), // фикс пропадающего border-bottom для строки заголовков в firefox
        Array.isArray(value) ? value.map(function (fileInfo, index) {
          var isLastItem = value.length - 1 === index;
          return _this.createFileListItem(isGetView, fileInfo, index, isLastItem);
        }) : null]);
        return updatedFilesTbodyContainer;
      }
    }, {
      key: "createFileListItem",
      value: function createFileListItem(isGetView, fileInfo, index, isLastItem) {
        var _this = this;

        var fileNameWithoutExt = _this.fileNameWithoutExt(fileInfo);

        var fileExt = _this.fileExt(fileInfo);

        var fileId = fileInfo.data.id;
        var fileAuthor = this.fileAuthor(fileInfo);
        var fileSize = this.fileSize(fileInfo.size);
        var fileUploadDate = this.fileUploadDate(fileInfo);
        var fileItemTitleCellStyles = commonTableCellStyles + 'max-width: 400px';
        var fileItemSizeCellStyles = commonTableCellStylesWithEllipsisStyles + 'max-width: 100px; width: 100px;';
        var fileItemAuthorCellStyles = commonTableCellStylesWithEllipsisStyles + 'max-width: 250px; width: 250px;';
        var fileItemUploadDateCellStyles = commonTableCellStylesWithEllipsisStyles + 'max-width: 162px; width: 162px;';
        var fileItem = this.ce('tr', _objectSpread({}, isLastItem && borderNoneObj), [this.ce('td', {
          title: fileInfo.data.name,
          style: fileItemTitleCellStyles
        }, [this.createBlockFileLink(baseUrl, fileInfo, isGetView, [this.ce('span', {
          class: 'file-list__file-name',
          style: 'margin-right: 10px; display: flex; width: 100%'
        }, [this.ce('span', {
          class: 'file-name__name',
          style: 'overflow-x: hidden; text-overflow: ellipsis'
        }, fileNameWithoutExt), this.ce('span', {
          class: 'file-name__ext'
        }, fileExt)])])]), this.component.isShowSize && this.ce('td', {
          class: 'file-list__file-size',
          style: fileItemSizeCellStyles,
          title: fileSize
        }, fileSize), this.component.isShowAuthor && this.ce('td', {
          class: 'file-list__file-author',
          style: fileItemAuthorCellStyles,
          title: fileAuthor
        }, fileAuthor), this.component.isShowUploadDate && this.ce('td', {
          class: 'file-list__file-upload-date',
          style: fileItemUploadDateCellStyles,
          title: fileUploadDate
        }, fileUploadDate), !this.disabled && !this.shouldDisable && this.ce('td', null, this.ce('button', {
          class: 'file-list__file-remove icon-button',
          style: 'background: none; border: none',
          onClick: function onClick(event) {
            _this.splice(index);

            _this.refreshDOM();

            _this.triggerFileChange();

            event.preventDefault();
          }
        }, this.ce('i', {
          class: 'theme-icon-trash'
        }))), this.ce('td', {}, this.ce('div', {
          id: "signature-".concat(fileId),
          title: '',
          style: 'margin-left: 20px'
        }))]);
        var addDigitalSignatureButtonProps = {
          setting: setting,
          fileItem: fileItem,
          fileNameWithoutExt: fileNameWithoutExt,
          fileExt: fileExt,
          fileId: fileId,
          fileInfo: fileInfo,
          downloadFile: this.getDownloadFileFunction(baseUrl, fileInfo)
        };

        if (isGetView) {
          this.addDigitalSignatureButtonPropsList.push(addDigitalSignatureButtonProps);
        } else {
          this.addDigitalSignatureButton(addDigitalSignatureButtonProps);
        }

        return fileItem;
      }
    }, {
      key: "createBlockFileLink",
      value: function createBlockFileLink(baseUrl, file, isGetView, content) {
        if (this.options.uploadOnly) {
          return content;
        }

        var _this = this;

        var url = _this.getDownloadUrl(baseUrl, file);

        var getViewAdditionalData = {
          'data-type': file.type,
          'data-originalname': file.originalName
        };
        var linkElement = this.ce('a', _objectSpread({}, isGetView && getViewAdditionalData, {
          href: url,
          target: '_blank',
          class: 'file-list__block-file-link',
          style: 'display: inline-flex; justify-content: space-between; max-width: 100%; margin-right: 5px',
          onClick: _this.getDownloadFileFunction(baseUrl, file)
        }), content);

        if (isGetView) {
          linkElement.setAttribute('onclick', 'Formio.downloadFileAttributeCallback(event, this)');
        }

        return linkElement;
      }
    }, {
      key: "createImageListItem",
      value: function createImageListItem(fileInfo, index) {
        var _this8 = this;

        var image = this.ce('img', {
          alt: fileInfo.originalName || fileInfo.name,
          style: 'width:'.concat(this.component.imageSize, 'px')
        });

        if (this.loadingImages[index]) {
          this.loadingImages[index].then(function (url) {
            image.src = url;
          });
        }

        return this.ce('div', {}, this.ce('span', {}, [image, !this.disabled ? this.ce('i', {
          class: this.iconClass('remove'),
          onClick: function onClick(event) {
            _this8.splice(index);

            _this8.refreshDOM();

            event.preventDefault();
          }
        }) : null]));
      }
    }, {
      key: "createFileLink",
      value: function createFileLink(file) {
        var fileName = this.fileNameWithoutExt(file);

        if (this.options.uploadOnly) {
          return fileName;
        }

        var path = file.url,
            pathPrefix = path.startsWith('/') ? '' : '/',
            url = path.startsWith('http') ? path : "".concat(baseUrl).concat(pathPrefix).concat(path);
        return this.ce('a', {
          href: url,
          target: '_blank'
        }, fileName);
      }
    }, {
      key: "fileExt",
      value: function fileExt(file) {
        var fileName = file.originalName || file.name,
            parts = fileName.split('.');
        return parts.length > 1 ? '.'.concat(parts.pop()) : '';
      }
    }, {
      key: "fileNameWithoutExt",
      value: function fileNameWithoutExt(file) {
        var ext = this.fileExt(file);
        return (file.originalName || file.name).replace(ext, '');
      }
    }, {
      key: "fileAuthor",
      value: function fileAuthor(file) {
        var _file$data, _file$data$author;

        return ((_file$data = file.data) === null || _file$data === void 0 ? void 0 : (_file$data$author = _file$data.author) === null || _file$data$author === void 0 ? void 0 : _file$data$author.fullName) || '';
      }
    }, {
      key: "fileUploadDate",
      value: function fileUploadDate(file) {
        try {
          var _file$data2;

          var timestampString = (_file$data2 = file.data) === null || _file$data2 === void 0 ? void 0 : _file$data2.created;
          return (0, _momentTimezone.default)(timestampString).tz('Europe/Moscow').format('DD.MM.YYYY HH:mm МСК');
        } catch (e) {
          return '';
        }
      }
    }, {
      key: "getFile",
      value: function getFile(fileInfo, url) {
        var options = {
          method: 'GET',
          mode: 'cors',
          headers: {
            Accept: '*/*'
          },
          credentials: 'include',
          responseType: 'blob'
        };
        (0, _fileUtils.fetchAndDownloadFile)(url, options, fileInfo.originalName, fileInfo.type);
      }
    }, {
      key: "triggerFileChange",
      value: function triggerFileChange() {
        this.triggerChange({
          modified: true
        });
      }
    }, {
      key: "upload",
      value: function upload(files) {
        _get(_getPrototypeOf(CategoryFile.prototype), "upload", this).call(this, baseUrl, files);
      }
    }, {
      key: "defaultSchema",
      get: function get() {
        return CategoryFile.schema();
      }
    }], [{
      key: "schema",
      value: function schema() {
        for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
          extend[_key] = arguments[_key];
        }

        return _File.default.schema.apply(_File.default, [{
          type: 'categoryFile',
          label: 'Category File',
          key: 'categoryFile',
          image: false,
          privateDownload: false,
          imageSize: '200',
          filePattern: '*',
          fileMinSize: '0KB',
          fileMaxSize: '1GB',
          uploadOnly: false,
          defaultPropertyName: 'files_'
        }].concat(extend));
      }
    }, {
      key: "editForm",
      value: function editForm() {
        for (var _len2 = arguments.length, extend = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          extend[_key2] = arguments[_key2];
        }

        return _File2.default.apply(void 0, [[{
          key: 'display',
          components: [].concat(fileComponents)
        }, {
          key: 'digitalSignature',
          label: 'Электронная подпись',
          components: _toConsumableArray(_WithFileUtils.digitalSignatureComponents)
        }]].concat(extend));
      }
    }, {
      key: "builderInfo",
      get: function get() {
        return {
          title: 'Category File',
          icon: 'fa fa-file',
          group: 'advanced',
          weight: 70,
          schema: CategoryFile.schema()
        };
      }
    }]);

    return CategoryFile;
  }((0, _WithLogic2.default)((0, _WithFileUtils.WithFileUtils)(_File.default, setting)));

  return CategoryFile;
};

exports.default = _default;
var fileComponents = [{
  type: 'select',
  input: true,
  weight: -9,
  key: 'variant',
  tooltip: 'Select file input variant',
  label: 'Вариант поля',
  defaultValue: 'staticSet',
  validate: {
    required: true
  },
  data: {
    values: [{
      label: 'Без категорий',
      value: 'withoutCategory'
    }, {
      label: 'Динамический набор категорий',
      value: 'dynamicSet'
    }, {
      label: 'Статичный набор категорий',
      value: 'staticSet'
    }]
  }
}, {
  type: 'checkbox',
  input: true,
  weight: -8,
  key: 'hideCategory',
  label: 'Скрыть столбец "Категория"',
  conditional: {
    json: {
      '===': [{
        var: 'data.variant'
      }, 'staticSet']
    }
  }
}, {
  type: 'checkbox',
  input: true,
  weight: -7,
  key: 'hideTitles',
  label: 'Скрыть заголовки таблицы'
}, {
  type: 'htmlelement',
  tag: 'div',
  weight: -6,
  content: "\n              <span style=\"display: inline-block; max-width: 100%; font-weight: 700;\">\n                  \u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0430\u0442\u0440\u0438\u0431\u0443\u0442\u044B\n              </span>\n    "
}, {
  type: 'checkbox',
  input: true,
  weight: -5,
  key: 'isShowSize',
  defaultValue: true,
  label: 'Размер'
}, {
  type: 'checkbox',
  input: true,
  weight: -4,
  key: 'isShowAuthor',
  label: 'Автор'
}, {
  type: 'checkbox',
  input: true,
  weight: -3,
  key: 'isShowUploadDate',
  label: 'Дата загрузки'
}, {
  type: 'textfield',
  input: true,
  weight: -2,
  key: 'catalogCode',
  label: 'Код каталога в сервисе каталогов',
  placeholder: 'OKSMCountries',
  validate: {
    required: true
  },
  conditional: {
    json: {
      '!==': [{
        var: 'data.variant'
      }, 'withoutCategory']
    }
  }
}, {
  type: 'textfield',
  input: true,
  weight: -1,
  key: 'categoryCode',
  label: 'Код категории',
  placeholder: 'category',
  validate: {
    required: true
  },
  conditional: {
    json: {
      '===': [{
        var: 'data.variant'
      }, 'staticSet']
    }
  }
}];